import { render } from "./PixSelectionContainer.vue?vue&type=template&id=3de85f8c"
import script from "./PixSelectionContainer.vue?vue&type=script&lang=js"
export * from "./PixSelectionContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__